module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-row tc",
    class: _vm.customClass
  }, [(_vm.title) ? _c('label', {
    staticClass: "cera-round-pro fw6 db title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row tc toggle-row"
  }, [_c('input', {
    staticClass: "dn br3",
    class: _vm.disabled ? 'no-pointer' : '',
    attrs: {
      "id": _vm.toggleName + '1',
      "disabled": _vm.disabled,
      "name": _vm.toggleName,
      "type": "radio"
    },
    domProps: {
      "checked": _vm.toggleValue
    },
    on: {
      "input": _vm.setFirstValue
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "inter f6 pa2 tc b buttonUnselected left",
    class: [_vm.customTextClass, _vm.disabled ? '' : 'pointer'],
    attrs: {
      "for": _vm.toggleName + '1',
      "tabindex": "0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.firstOption) + "\n    ")]), _vm._v(" "), _c('input', {
    staticClass: "dn",
    attrs: {
      "id": _vm.toggleName + '2',
      "disabled": _vm.disabled,
      "name": _vm.toggleName,
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.toggleValue
    },
    on: {
      "input": _vm.setSecondValue
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "inter f6 pa2 tc b buttonUnselected right",
    class: [_vm.customTextClass, _vm.disabled ? '' : 'pointer'],
    attrs: {
      "for": _vm.toggleName + '2',
      "tabindex": "0"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.secondOption) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518c0044","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/PlanTypeToggle.vue
// module id = 697
// module chunks = 0